import { Injectable, inject } from "@angular/core";
import { CampaignType, SDStrategy, SdStrategyCreateRequest } from "@front/m19-api-client";
import { SdStrategyService } from "@front/m19-services";
import { Observable } from "rxjs";
import { BulkUploadRowPreview } from "../bulk-upload-context.service";
import { BulkFieldValidator, StrategyBulkUploadHandler } from "../strategy/strategy-bulk-upload-handler.service";

@Injectable()
export class SdBulkUploadHandler extends StrategyBulkUploadHandler<SDStrategy> {
  private readonly sdStrategyService = inject(SdStrategyService);

  protected readonly campaignType = CampaignType.SD;
  protected readonly bulkConfig = this.bulkImportService.getSdStrategyBulkConfig();

  protected buildCreateRequest$(creation: BulkUploadRowPreview<SDStrategy>): Observable<SDStrategy> {
    const parsed = creation.parsedEntity;
    const body: SdStrategyCreateRequest = {
      name: parsed.name!,
      asins: parsed.asins?.map((a) => a.asin) ?? [],
      algoMode: parsed.algoMode!,
      dailyBudget: parsed.dailyBudget,
      monthlyBudget: parsed.monthlyBudget,
      acosTarget: parsed.acosTarget,
      suggestedBid: parsed.suggestedBid,
      disableOtherQueries: parsed.disableOtherQueries,
      state: parsed.state,
    };

    return this.sdStrategyService.createStrategy(body);
  }

  protected getFieldValidators(): Partial<Record<keyof SDStrategy, BulkFieldValidator<SDStrategy>>> {
    return {
      strategyId: (entity) => this.validateStrategyIdNumber(entity),
      name: (entity) => this.validateName(entity),
      state: (entity) => this.validateState(entity),
      asins: (entity) => this.validateAsins(entity),
    };
  }

  protected getCreationFieldValidators(): Partial<Record<keyof SDStrategy, BulkFieldValidator<SDStrategy>>> {
    return {};
  }

  protected getUpdateFieldValidators(): Partial<Record<keyof SDStrategy, BulkFieldValidator<SDStrategy>>> {
    return {
      strategyId: (entity) => this.validateStrategyExists(entity),
      state: (entity) => this.validateStateOnUpdate(entity),
      name: (entity) => this.validateNameOnUpdate(entity),
    };
  }
}
